import React, {PureComponent} from 'react';
import SmartPromotionList from 'app/components/pages/home_page/SmartPromotion/SmartPromotionList';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';

interface LetsShowProps {
    loadArticles: () => void
    type_left: string
    nameForControls_left: string
    data_left: ArticleInterface[]
    type_right: string
    nameForControls_right: string
    data_right: ArticleInterface[]
}

export default class LetsShow extends PureComponent<LetsShowProps> {
    constructor(props: LetsShowProps) {
        super(props);
        this.props.loadArticles();
    }

    render(): React.ReactNode {
        const {data_left, data_right, type_left, type_right, nameForControls_right, nameForControls_left} = this.props;
        return <div className="lets-show">
            <div className="lets-show__part">
                <SmartPromotionList
                    data={data_left}
                    type={type_left}
                    nameForControls={nameForControls_left}
                />
            </div>
            {data_right.length > 0 && <div className="lets-show__part">
                <SmartPromotionList
                    data={data_right}
                    type={type_right}
                    nameForControls={nameForControls_right}
                />
            </div>}
        </div>;
    }
}
